// extracted by mini-css-extract-plugin
export default {"notificationButton":"NotificationButton-module__notificationButton--ReJzI","buttonWrapper":"NotificationButton-module__buttonWrapper--el7AE"};